"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import BottomNav from "@/components/BottomNav";
import { isNativeShell } from "@/lib/native-shell";

// "/privacy" อยู่ที่นี่เพราะ Google Play ต้องเปิด URL นี้ได้โดยไม่ต้องล็อกอิน —
// reviewer กดจากหน้า store ตรงมาเลย ถ้าโดน BottomNav ครอบจะดูเหมือนหน้าในแอป
// ไม่ใช่หน้านโยบายสาธารณะ
const PUBLIC_ROUTES = ["/login", "/register", "/forgot-password", "/select-org", "/change-password", "/guest", "/privacy"];

export function AppShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname() ?? "/";

  // ADR 0289 · ADR 0168 (driver) — the bottom safe area has ONE owner.
  // `apps/passenger-app/App.tsx` wraps the WebView in
  // `<SafeAreaView edges={Platform.OS === "ios" ? [] : ["bottom"]}>`, so inside the
  // shell on Android the strip is already reserved natively; the web must then zero
  // its own or every bottom bar pads twice and floats above the system navigation.
  //
  // Platform comes from the user agent because this shell deliberately has no
  // bridge (ADR 0001 D5) — there is no `bottomInsetOwner` message to read, and the
  // rule the shell follows is known and platform-based.
  useEffect(() => {
    const nativeAndroid = isNativeShell() && /Android/i.test(navigator.userAgent);
    document.documentElement.classList.toggle("native-owns-bottom-inset", nativeAndroid);
  }, []);
  const isPublic = PUBLIC_ROUTES.some((p) => pathname.startsWith(p));

  if (isPublic) {
    return <main className="flex-1">{children}</main>;
  }

  return (
    <>
      <main className="has-bottom-nav flex-1 pb-[72px]">{children}</main>
      <BottomNav />
    </>
  );
}
